/* eslint-disable no-console */
import { DEV } from 'application/consts';

export type TLogUtils = {
  debug: (message: string, ...args: any[]) => false | void;
  info: (message: string, ...args: any[]) => false | void;
  warn: (message: string, ...args: any[]) => false | void;
  error: (message: string, error?: any) => void;
  pause: () => void;
  resume: () => void;
};

class Logger {
  private paused = false;

  private context: string;

  constructor(context: string) {
    this.context = context;
  }

  private shouldLog(): boolean {
    return DEV && !this.paused;
  }

  debug(message: string, ...args: any[]) {
    if (this.shouldLog()) {
      console.log(`🔍 [${this.context}] ${message}`, ...args);
    }
  }

  info(message: string, ...args: any[]) {
    if (this.shouldLog()) {
      console.info(`ℹ️ [${this.context}] ${message}`, ...args);
    }
  }

  warn(message: string, ...args: any[]) {
    if (this.shouldLog()) {
      console.warn(`⚠️ [${this.context}] ${message}`, ...args);
    }
  }

  error(message: string, error?: any) {
    const prefix = `[${this.context}] `;

    if (DEV && !this.paused) {
      console.error(`❌ ${prefix}${message}`, error || '');
    } else if (!this.paused) {
      console.error(`Error: ${prefix}${message}`);
    }
  }

  pause() {
    this.paused = true;
  }

  resume() {
    this.paused = false;
  }
}

export const createLogger = (context: string): TLogUtils => new Logger(context);
